package ui.consumerInformation

import ConfigFile
import androidx.compose.runtime.Composable
import androidx.compose.runtime.DisposableEffect
import androidx.compose.runtime.remember
import androidx.lifecycle.ViewModel
import kotlinx.coroutines.flow.StateFlow
import model.ConsumerInformationV3
import model.DataRepository
import model.MerchantFullInformationV3
import org.koin.compose.koinInject
import ui.DisposableViewModel
import ui.ScopeHolderFactory

@Composable
fun consumerInformationViewModel(
    scopeHolderFactory: ScopeHolderFactory = koinInject(),
): ConsumerInformationViewModel {
    val scopeHolder = remember { scopeHolderFactory.getOrCreate(ConsumerInformationViewModel::class) }
    DisposableEffect(Unit) { onDispose { scopeHolder.detach() } }
    return remember { scopeHolder.attach() }
}

class ConsumerInformationViewModel(
    val dataRepository: DataRepository,
    val clientConfig: ConfigFile,
) : ViewModel(), DisposableViewModel {

    val consumerInformationStateFlow: StateFlow<ConsumerInformationV3?> = dataRepository.consumerInformationStateFlow

    fun setMerchant(merchant: MerchantFullInformationV3) {
        dataRepository.setMerchant(merchant)
    }

    override fun dispose() {
        println("ConsumerInformationViewModel.dispose")
    }
}